var map = {
	"./1-DR. VIKAS PANDEY-NATIONAL PRESIDENT.jpeg": 18646,
	"./10- Vinita Pandey - National Treasurer.jpg": 34321,
	"./2- Dr. PVG Viswnath - National  VIce  President.jpg": 65795,
	"./3-Dr. S. Geetha Kumari - National Vice President.jpg": 37549,
	"./4- D.M.Rao, CA - National Secretary.jpeg": 8785,
	"./5- Doddi Chandrasekhar - National Secretary.jpg": 21333,
	"./6- Mr. P. S. Prasad Raju -National Secretary.jpg": 82588,
	"./7- Mr. Durga Rao - National Secretary.jpg": 38700,
	"./8- Mr. Avinash Benjamin-National Spokesperson.jpg": 5504,
	"./9- Mr. BNS Vara Prasad - National Auditor.jpg": 30101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18786;